import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import { ErrorMessage } from "components/DesignSystem/TextInput/TextInput";
import { FORM_FILING_TYPE } from "constants/taskStates";
import dayjs from "dayjs";
import { TASK_STATE_TO_COLOR } from "dictionaries";
import { openLink } from "utils/openLink";

export const TaskCard = ({
  task,
  isInvalid,
}: {
  task: {
    uuid: string;
    title: string;
    state_type: string | null;
    state_name: string | null;
    deadline: string | null;
  };
  isInvalid: boolean;
}) => {
  const { uuid, title, state_type, state_name } = task;
  const isTask5471 = title?.includes("5471");

  return (
    <div>
      <div
        className={classNames(
          "t-p-4 t-rounded t-border t-border-solid t-border-neutral-0 t-flex t-gap-16 t-justify-between",
          {
            "t-border-red": isInvalid,
          }
        )}
      >
        <div>
          <div className="t-text-subtext t-text-text-100">{title}</div>
          <div className="t-text-body-sm t-text-neutral-40 t-my-1">
            {isTask5471
              ? "Required for US persons who own or control a foreign corporation"
              : "Required for US corporations with foreign owners or transactions with foreign entities"}
          </div>

          <div className="t-text-body-sm t-text-text-30">
            Deadline:{" "}
            {task.deadline ? dayjs(task.deadline).format("MMMM D, YYYY") : "-"}
          </div>
        </div>
        <div>
          {!state_type || state_type === FORM_FILING_TYPE ? (
            <Button
              customType="primary"
              size="small"
              onClick={() => openLink(`/tax/filings/${uuid}`)}
            >
              Go to Filing
            </Button>
          ) : (
            <Tag
              tagType={
                (TASK_STATE_TO_COLOR[
                  state_type as keyof typeof TASK_STATE_TO_COLOR
                ] as TagColorType) || "gray"
              }
              icon={false}
              size="small"
            >
              {state_name}
            </Tag>
          )}
        </div>
      </div>
      {isInvalid && (
        <ErrorMessage>
          Form 1120 submission requires completed Form 5471/5472. Please fill
          this form and move it to In-Progress.
        </ErrorMessage>
      )}
    </div>
  );
};
